import { useState } from "react";
import styles from "./sorting.module.scss"; // Import CSS for styling
import tableStyles from "./table.module.scss";
import { Button } from "@components/button";
import Arrows from "@assets/icons/arrows.svg";

// Define the props interface
interface SortingComponentProps {
  config: SortingConfig;
}

type LabelDirection = { type: "asc" | "desc"; label: string };

export type SortingConfig = {
  items: {
    name: string;
    typeLabel: string;
    labels: [LabelDirection, LabelDirection];
  }[];
  onSortChange: (sort: { type: string; direction: string }) => void;
};

// Define the SortingComponent
const SortingComponent = ({
  config,
}: SortingComponentProps) => {
  // State to manage dropdown visibility
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  // State to track the current sorting type and direction
  const [currentSort, setCurrentSort] = useState<{
    type: string;
    direction: string;
  }>({
    type: "",
    direction: "",
  });

  // Toggle dropdown visibility
  const toggleDropdown = () => {
    console.log(isDropdownOpen);
    setIsDropdownOpen(!isDropdownOpen);
  };

  // Handle selection of a sorting option
  const handleSortSelect = (type: string, direction: string) => {
    setCurrentSort({ type, direction });
    setIsDropdownOpen(false); // Close dropdown after selection
    config.onSortChange({ type, direction }); // Call the callback with selected values
  };

  return (
    <div className={styles.sortingComponent}>
      <Button
        className={tableStyles.sortButton}
        type="outline"
        icon={Arrows}
        onClick={toggleDropdown}
        aria-haspopup="true"
        aria-expanded={isDropdownOpen}
      />
      {/* Sorting trigger button */}

      {/* Dropdown menu (shown only when isDropdownOpen is true) */}
      {isDropdownOpen && (
        <div className={styles.dropdownMenu} role="menu">
          {config.items.map((item, index) => (
            <div className={styles.dropdownSection} key={index}>
              <h4>{item.typeLabel}</h4>
              {item.labels.map((label, labelIndex) => (
                <button
                  onClick={() =>
                    handleSortSelect(item.name as string, label.type)
                  }
                  className={
                    currentSort.type === "amount" &&
                    currentSort.direction === "desc"
                      ? "active"
                      : ""
                  }
                  key={labelIndex}
                >
                  {label.label}
                </button>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SortingComponent;
